export const SIGN_OUT = 'SIGN_OUT';

export const signOut = () => ({ type: SIGN_OUT });



// WEBPACK FOOTER //
// ./src/redux/actions/signOut.js